module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp23_5012.aef71545.png";